import React, { useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useFirebase } from "../context/ApiContext";

const EmailVerificationBanner = () => {
	const { user, emailVerified, resendVerificationEmail } = useFirebase();
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);
	const [dismissed, setDismissed] = useState(false);

	if (!user || emailVerified || dismissed) return null;

	const handleResend = async () => {
		setSending(true);
		try {
			await resendVerificationEmail();
			setSent(true);
			setTimeout(() => setSent(false), 5000);
		} catch {
			// silently fail
		} finally {
			setSending(false);
		}
	};

	return (
		<Box
			sx={{
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				width: "100%",
				background: "linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)",
				borderTop: "1px solid rgba(245, 158, 11, 0.2)",
				boxShadow: "0 -2px 10px rgba(0,0,0,0.08)",
				px: 2,
				py: 3,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				gap: 1.5,
				flexWrap: "wrap",
				zIndex: 9999,
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
				<MailOutlineIcon sx={{ fontSize: 18, color: "#92400e" }} />
				<Typography
					sx={{
						fontSize: 13,
						fontWeight: 600,
						color: "#92400e",
						fontFamily: "'Inter', sans-serif",
					}}
				>
					Verifica tu email para desbloquear todas las funciones
				</Typography>
			</Box>
			<Button
				size="small"
				onClick={handleResend}
				disabled={sending || sent}
				disableElevation
				sx={{
					textTransform: "none",
					fontSize: 12,
					fontWeight: 600,
					color: "#fff !important",
					backgroundColor: "#d97706 !important",
					background: "#d97706 !important",
					borderRadius: "8px",
					border: "none !important",
					boxShadow: "none",
					outline: "none",
					"&:focus": { outline: "none", boxShadow: "none" },
					px: 2,
					py: 0.5,
					minWidth: "auto",
					lineHeight: 1.5,
					fontFamily: "'Inter', sans-serif",
					"&:hover": {
						backgroundColor: "#b45309 !important",
						background: "#b45309 !important",
						border: "none !important",
						boxShadow: "none",
					},
					"&.Mui-disabled": {
						backgroundColor: "#c4a35a !important",
						color: "rgba(255,255,255,0.7) !important",
					},
					"& .MuiButton-label": { color: "#fff !important" },
				}}
			>
				{sending ? (
					<CircularProgress size={14} sx={{ color: "#fff" }} />
				) : sent ? (
					"Email enviado ✓"
				) : (
					"Reenviar email"
				)}
			</Button>
		</Box>
	);
};

export default EmailVerificationBanner;
